import * as therapeuticType from "../../action/actiontype/PlanTherapeuticType/PlanTherapeutic";

const therapeuticReducer = (state = {}, action) => {
    switch (action.type) {

        case therapeuticType.PLANTHERAPEUTIC_GETALL_REQUEST:
            return {
                ...state,
                therapeuticListLoading: true,
                therapeuticListResponse: {},
                therapeuticListError: null
            }
        case therapeuticType.PLANTHERAPEUTIC_GETALL_SUCCESS:
            return {
                ...state,
                therapeuticListLoading: false,
                therapeuticListResponse: action.payload,
                therapeuticListError: null
            }
        case therapeuticType.PLANTHERAPEUTIC_GETALL_FAILURE:
            return {
                ...state,
                therapeuticListLoading: false,
                therapeuticListError: action.payload,
                therapeuticListResponse: {}
            }

        // Therapeutic Plan Create
        case therapeuticType.PLANTHERAPEUTIC_CREATE_REQUEST:
            return {
                ...state,
                therapeuticCreateLoading: true,
                therapeuticCreateResponse: {},
                therapeuticCreateError: null
            }
        case therapeuticType.PLANTHERAPEUTIC_CREATE_SUCCESS:
            return {
                ...state,
                therapeuticCreateLoading: false,
                therapeuticCreateResponse: action.payload,
                therapeuticCreateError: null
            }
        case therapeuticType.PLANTHERAPEUTIC_CREATE_FAILURE:
            return {
                ...state,
                therapeuticCreateLoading: false,
                therapeuticCreateError: action.payload,
                therapeuticCreateResponse: {}
            }

            // Therapeutic Plan Update
        case therapeuticType.PLANTHERAPEUTIC_CREATE_REQUEST:
            return {
                ...state,
                therapeuticCreateLoading: true,
                therapeuticCreateResponse: {},
                therapeuticCreateError: null
            }
        case therapeuticType.PLANTHERAPEUTIC_CREATE_SUCCESS:
            return {
                ...state,
                therapeuticCreateLoading: false,
                therapeuticCreateResponse: action.payload,
                therapeuticCreateError: null
            }
        case therapeuticType.PLANTHERAPEUTIC_CREATE_FAILURE:
            return {
                ...state,
                therapeuticCreateLoading: false,
                therapeuticCreateError: action.payload,
                therapeuticCreateResponse: {}
            }
            // Therapeutic plan Delete
            case therapeuticType.PLANTHERAPEUTIC_DELETE_REQUEST:
                return {
                    ...state,
                    therapeuticDeleteLoading: true,
                    therapeuticDeleteResponse: {},
                    therapeuticDeleteError: null
                }
            case therapeuticType.PLANTHERAPEUTIC_DELETE_SUCCESS:
                return {
                    ...state,
                    therapeuticDeleteLoading: false,
                    therapeuticDeleteResponse: action.payload,
                    therapeuticDeleteError: null
                }
            case therapeuticType.PLANTHERAPEUTIC_DELETE_FAILURE:
                return {
                    ...state,
                    therapeuticDeleteLoading: false,
                    therapeuticDeleteError: action.payload,
                    therapeuticDeleteResponse: {}
                }

        // Drugs Get
        case therapeuticType.GET_DRUGS_GETALL_REQUEST:
            return {
                ...state,
                therapeuticDrugListLoading: true,
                therapeuticDrugListResponse: {},
                therapeuticDrugListError: null
            }
        case therapeuticType.GET_DRUGS_GETALL_SUCCESS:
            return {
                ...state,
                therapeuticDrugListLoading: false,
                therapeuticDrugListResponse: action.payload,
                therapeuticDrugListError: null
            }
        case therapeuticType.GET_DRUGS_GETALL_FAILURE:
            return {
                ...state,
                therapeuticDrugListLoading: false,
                therapeuticDrugListError: action.payload,
                therapeuticDrugListResponse: {}
            }


        default:
            return state;
    }
}
export default therapeuticReducer;